<template lang="pug">
#modal-confirmar-excluir
    el-dialog(
        width='450px',
        title='Excluir',
        :visible.sync='mostrar',
        :close-on-click-modal='false',
        :before-close='fechar'
    )
        el-p Deseja realmente excluir a ordem de corte número {{numeroOrdemCorte}}?
        br
        el-p Essa ação não poderá ser desfeita.

        footer.espaco(slot='footer')
            BaseButton(type='default', @click='fechar') Cancelar

            BaseButton(
                type='primary',
                @click='excluir'
            ) Confirmar

</template>

<script>
import RastreabilidadeOrdemDeCorteService from '@/services/RastreabilidadeOrdemDeCorteService';
import BaseButton from '@/components/vegaComponents/BaseButton.vue';

export default {
    name: 'ModalConfirmarExcluir',
    components: {
        BaseButton
    },
    emits: ['atualizarDadosDeCorte'],
    props: {
        mostrar: {
            type: Boolean,
            required: true
        },

        dadosOrdemDeCorte: {
            type: Object,
            required: false,
            default: null
        }
    },

    data() {
        return {
            id: '',
            numeroOrdemCorte: ''
        };
    },

    watch: {
        mostrar() {
            if (this.dadosOrdemDeCorte) {
                this.id = this.dadosOrdemDeCorte.id;
                this.numeroOrdemCorte = this.dadosOrdemDeCorte.numeroOrdemCorte;
            }
        }
    },

    methods: {
        fechar() {
            this.$emit('fechar');
        },

        async excluir() {
            try {
                await RastreabilidadeOrdemDeCorteService.excluirOrdemDeCorte({
                    id: this.dadosOrdemDeCorte.id
                });

                this.fechar();
                this.$emit('atualizarDadosDeCorte');

                this.$notify.success({
                    message: 'Ordem de corte excluida com sucesso'
                });
            } catch (e) {
                this.$notify.error({
                    message: e.response.data.message
                });
            }
        }
    }
};
</script>

<style lang="scss">
footer {
    display: flex;
    justify-content: space-between;
}

.invalido {
    color: var(--danger);
}

.espaco {
    display: flex;
}

.el-date-editor.el-input {
    width: 100%;
}
</style>
